// extracted by mini-css-extract-plugin
export default {"container":"Charts_container__kf4T8","chart1":"Charts_chart1__sm1ID"};